import { Injectable, inject } from '@angular/core';
import { PlayReportingService } from './play-reporting.service';
import { PlayDatabaseInteraction } from '@r1-compass-library/models/reporting/reporting-data.model';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, of, retry } from 'rxjs';
import { DatabaseInteractionSearch } from '@r1-compass-library/models/reporting/reporting-search.model';
import { AllCharacterHttpParamsEncoder } from '@r1-compass-library/utilities/AllCharacterHttpParamsEncoder';
import { Environment } from '@r1-compass-library/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PlayDatabaseInteractionService extends PlayReportingService {
    readonly #http = inject(HttpClient);

    private DATABASE_INTERACTION_URL: string = Environment.baseUrl + '/frontend/play-database-interactions';

    constructor() {
        super();
    }

    find(search: DatabaseInteractionSearch): Observable<PlayDatabaseInteraction[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({
                encoder: new AllCharacterHttpParamsEncoder(),
            }),
        };
        this.addSearchParams(search, customHttpOptions);
        return this.#http.get<PlayDatabaseInteraction[]>(this.DATABASE_INTERACTION_URL, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<PlayDatabaseInteraction[]>();
            })
        );
    }

    getJoinedAggregates(search: DatabaseInteractionSearch): Observable<object[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({
                encoder: new AllCharacterHttpParamsEncoder(),
            }),
        };

        this.addSearchParams(search, customHttpOptions);

        return this.#http.get<object[]>(`${this.DATABASE_INTERACTION_URL}/joined-aggregates`, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<object[]>();
            })
        );
    }
}
